// extracted by mini-css-extract-plugin
export default {"root":"SupportContent_root__CU6-Z"};